import { MAIN_PAGE, COOKIES_NAMES } from '../variables/common';
import { createBrowserHistory } from 'history';
import Cookies from 'universal-cookie';

const history = createBrowserHistory();
const cookies = new Cookies(null, { path: process.env.REACT_APP_API_PREFIX});

//* for unit-test
export const handleSubmit = (values, callback) => {
    callback(values);
};


class Auth {
    constructor() {
        console.log
        if (cookies.get(COOKIES_NAMES.OAUTH)) {
            localStorage.setItem(COOKIES_NAMES.EMAIL, cookies.get(COOKIES_NAMES.EMAIL) || null);
            localStorage.setItem(COOKIES_NAMES.ROLE, cookies.get(COOKIES_NAMES.ROLE) || null);
            localStorage.setItem(COOKIES_NAMES.GROUP, cookies.get(COOKIES_NAMES.GROUP) || null);
            localStorage.setItem(COOKIES_NAMES.FULL_NAME, cookies.get(COOKIES_NAMES.FULL_NAME) || null);

            cookies.remove(COOKIES_NAMES.OAUTH);
            cookies.remove(COOKIES_NAMES.EMAIL);
            cookies.remove(COOKIES_NAMES.ROLE);
            cookies.remove(COOKIES_NAMES.GROUP);
            cookies.remove(COOKIES_NAMES.FULL_NAME);
        }
    }

    get isAuthenticated() {
        if (cookies.get(COOKIES_NAMES.JWT)) {
            return true;
        }
        return false;
    }
    get role() {
        return localStorage.getItem(COOKIES_NAMES.ROLE) || null;
    }
    get token() {
        return cookies.get(COOKIES_NAMES.JWT) || null;
    }
    get jwt_decode() {
        return this.parseJwt(this.token) || null;
    }

    login(token, email, role, fullName, group) {
        localStorage.setItem(COOKIES_NAMES.EMAIL, email);
        localStorage.setItem(COOKIES_NAMES.ROLE, role);
        localStorage.setItem(COOKIES_NAMES.GROUP, group);
        localStorage.setItem(COOKIES_NAMES.FULL_NAME, fullName);
        cookies.set(COOKIES_NAMES.JWT, token);

        history.push(MAIN_PAGE, { jwt: cookies.get(COOKIES_NAMES.JWT) });
        history.go(0);
    }

    logout() {
        localStorage.removeItem(COOKIES_NAMES.EMAIL);
        localStorage.removeItem(COOKIES_NAMES.ROLE);
        localStorage.removeItem(COOKIES_NAMES.GROUP);
        localStorage.removeItem(COOKIES_NAMES.FULL_NAME);

        cookies.remove(COOKIES_NAMES.JWT);

        history.push(MAIN_PAGE);
        /* history.go(0); */
    }

    parseJwt(token) {
        try {
            let base64Url = token.split('.')[1];
            let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            let jsonPayload = decodeURIComponent(
                atob(base64)
                    .split('')
                    .map(function (c) {
                        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                    })
                    .join('')
            );
            return JSON.parse(jsonPayload);
        }
        catch (err) {
            return false
        }

    }
}

const auth = new Auth();

export default auth;
